import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';

import { DateHelper } from '../../helpers/date-helper';
import { FormHelper } from '../../helpers/form-helper';
import { Member } from '../../models/member';
import { MemberService } from '../../services/member.service';

@Component({
  selector: 'app-update-member',
  templateUrl: './update-member.component.html',
  styleUrls: ['./update-member.component.scss']
})
export class UpdateMemberComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	private key: string;

  constructor(private dialogRef: MdDialogRef<UpdateMemberComponent>,
							private formBuilder: FormBuilder,
							private memberService: MemberService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();
	}

  ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			name: new FormControl('', Validators.required),
			lastname: new FormControl('', Validators.required),
			phone: new FormControl('', Validators.required),
			email: new FormControl('', Validators.required)
		});
	}

	public updateForm(member: Member): void {
		this.key = member.$key;

		this.form.controls['name'].setValue(member.name);
		this.form.controls['lastname'].setValue(member.lastname);
		this.form.controls['phone'].setValue(member.phone);
		this.form.controls['email'].setValue(member.email);
	}

	public async submitForm(): Promise<any> {
		let member: Member = this.form.value;

		await this.memberService.updateMember(this.key, member);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/update-member/update-member.component.ts